import { Account } from './Account';
import { SettingsApi } from '../Settings/SettingsApi';
import { Api } from '@automapa/svelte-automapa-template';
import { AdminApi } from './AdminApi';

export class AccountApp {
    private _accounts: Account[] = [];
    private _onlyMyAccounts: boolean = false;

    constructor(onlyMyAccounts: boolean = false) {
        this._onlyMyAccounts = onlyMyAccounts;
    }

    public async prepareData(api: Api): Promise<this> {
        let response = await SettingsApi.getDemoAccounts__DEPRECATED(
            api,
            this._onlyMyAccounts
        ).catch(() => {
            console.error('Error fetching accounts');
        });
        if (response) {
            this._accounts = [];
            response.forEach(account => {
                this._accounts.push(new Account().set(account, account?.webuser_id ?? null));
            });
            console.log('AccountApp, fetched accounts:', this._accounts.length);
        } else {
            console.error('No accounts found');
            this._accounts = [];
        }
        return this;
    }

    public async getAllItems() {
        return this._accounts;
    }

    public async getFilteredItems(filter: string) {
        if (filter === '') {
            return this._accounts;
        }
        return this._accounts.filter(
            account =>
                account.getName().toLocaleLowerCase().includes(filter.toLocaleLowerCase()) ||
                account.getEmail().toLocaleLowerCase().includes(filter.toLocaleLowerCase()) ||
                account.getExpirationDate().includes(filter)
        );
    }

    public async save(account: Account) {
        alert('this feature is not implemented yet');
        // if (account.isNew()) {
        //     return Account.createOne(account.get());
        // }
        // return Account.updateOne(account.getId(), account.get());
    }

    // public async updateExpirationDate(api: Api, account: Account) {
    //     let config = await SettingsApi.getCustomerSettings(api);
    //     return SettingsApi.setCustomerSettings(
    //         api,
    //         {
    //             ...config.settings,
    //             expiration_date: account.getExpirationDate(),
    //         },
    //         account.getCustomerId()
    //     );
    // }

    public async updateExpirationDate(api: Api, account: Account) {
        return AdminApi.updateExpirationDate(
            api,
            account.getCustomerId(),
            account.getExpirationDate()
        );
    }

    public async updateSettingsReadonly(api: Api, account: Account) {
        return AdminApi.updateSettingsReadonly(
            api,
            account.getCustomerId(),
            account.getSettingsReadonly()
        );
    }

    public async create(api: Api, account: Account) {
        return AdminApi.createAccount(
            api,
            account.getName(),
            account.getEmail(),
            account.getExpirationDate(),
            account.getSettingsReadonly()
        );
    }
}
